import { Home } from './domain';

// Keeping the App component here to be used for routing, if needed
const App = () => <Home />;

export default App;
